jQuery(document).ready(function($){
	console.log('test');
	if($('.sct-contact-form').length) {
		setTimeout(function(){
			maybeDisableContactFormButton();
		}, 500);

		$('.sct-contact-form').on('change', '.co-field-wrapper.cohp input[name="cohp"]', function(){
			maybeDisableContactFormButton();
		});

		$('.sct-contact-form').on('change', '.co-field-wrapper.consent-checkbox-wrapper input[type="checkbox"]', function(){
			maybeDisableContactFormButton();
		});

		$('.sct-contact-form').on('focus', 'input, textarea', function(){
			const form = $(this).closest('form');
			if(form.find('.scfe-modal-wrapper').length) console.log('has modal');

			const notifiedClass = 'out-of-office--notified';

			if(!form.hasClass(notifiedClass)) {
				form.addClass(notifiedClass);

				form.find('.scfe-modal-wrapper').addClass('showing');
			}
		});

		setTimeout(function(){
			$('.sct-contact-form').each(function(){
				const formWrapper = $(this);
				if(formWrapper.find('.scfe-modal-wrapper').length) {
					formWrapper.find('input, textarea').each(function(){
						$(this).attr('autocomplete', 'off');
					});
				}
			});
		}, 500);


		setTimeout(function(){
			if($('.sct-contact-form:has(.cf-turnstile)').length) {
				const formsWithTurnstile = $('.sct-contact-form:has(.cf-turnstile)');
				let turnstileVerification = setInterval(function(){
					if($('.sct-contact-form:has(input[name="cf-turnstile-response"])').length) {
						maybeDisableContactFormButton();
						if(verifyCaptcha()) clearTimeout(turnstileVerification);
					}
				}, 1000);
			} else {
				console.log('no turnstile');
			}
		}, 1000);
	}

	function maybeDisableContactFormButton() {
		let passedChecks = true;

		if(!verifyHoneypot()) passedChecks = false;
		if(!verifyCheckboxes()) passedChecks = false;
		if(!verifyCaptcha()) passedChecks = false;

		$('.sct-contact-form').each(function(){
			const submitButton = $(this).find('button[type="submit"]');
			submitButton.each(function(){
				$(this).attr('disabled', !passedChecks).prop('disabled', !passedChecks);
			});
		});
	}

	function verifyHoneypot() {
		if($('.sct-contact-form:has(input[name="cohp"])').length) {
			let honeypotValue = $('.sct-contact-form input[name="cohp"]').val();
			return honeypotValue.length ? false : true;
		} else {
			return true;
		}
	}

	function verifyCheckboxes() {
		if($('.sct-contact-form:has(.consent-checkbox-wrapper)').length) {
			let consentGiven = true;
			$('.sct-contact-form:has(.consent-checkbox-wrapper)').each(function(){
				const checkboxes = $(this).find('.consent-checkbox-wrapper input[type="checkbox"]');

				console.log(checkboxes);

				checkboxes.each(function(){
					console.log(this.checked);
					if(!this.checked) consentGiven = false;
				});

			});
			return consentGiven;
		} else {
			return true;
		}
	}

	function verifyCaptcha() {
		if($('.sct-contact-form:has(.cf-turnstile)').length) {
			let passedChecks = true;
			$('.sct-contact-form:has(.cf-turnstile)').each(function(){
				const turnstileDiv = $(this).find('.cf-turnstile');
				const turnstileInput = turnstileDiv.find('input[name="cf-turnstile-response"]');
				const turnstileVal = (turnstileInput.length) ? turnstileInput.val() : '';

				if(!turnstileVal.length) passedChecks = false;
			});

			return passedChecks;
		} else {
			return true;
		}
	}
});